import { useEffect, useState } from "react";
import { ALL_COUNTRIES } from "@/context/countries";

export function useIpStackDetails(isAfricaPage: boolean = false) {
  const [ipStackDetails, setIpStackDetails] = useState<any>({});

  useEffect(() => {
    function getCountryData() {
      if (typeof window !== "undefined") {
        const countryData = JSON.parse(localStorage.getItem("ipDataStore_main") || "{}"); // countryData
        if (countryData && Object.keys(countryData).length > 0) {
          setIpStackDetails(countryData);
        } else {
          setTimeout(getCountryData, 1000);
        }
      }
    }
    // this will try to get the latest localStorage data
    setTimeout(getCountryData, 1000);
  }, []);

  return {
     countryCode: ipStackDetails?.location?.calling_code?"+"+ipStackDetails?.location?.calling_code:isAfricaPage? "+213" : "+91",
     ipStackDetails,
    };
}
